import { render, staticRenderFns } from "./CandidateMyTests.vue?vue&type=template&id=bcdf6562&scoped=true"
import script from "./CandidateMyTests.vue?vue&type=script&lang=js"
export * from "./CandidateMyTests.vue?vue&type=script&lang=js"
import style0 from "./CandidateMyTests.vue?vue&type=style&index=0&id=bcdf6562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdf6562",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VIcon,VProgressLinear,VSpacer})
